module.exports = __webpack_public_path__ + "static/media/IMGP0156.61bcad05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_bei_den_Umzuegen/IMGP0156.jpg
// module id = 446
// module chunks = 0